module.exports = __webpack_public_path__ + "static/img/HawaiiParadise-zh.8520b7c1.png";